import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconChatBubble: React.FC<IconProps> = ({ color = 'var(--color-primary-2-50)' }) => {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0009 7C16.0009 10.5906 12.4197 13.5 8.00093 13.5C6.84155 13.5 5.74155 13.3 4.7478 12.9406C4.37593 13.2125 3.76968 13.5844 3.05093 13.8969C2.30093 14.2219 1.3978 14.5 0.500927 14.5C0.297802 14.5 0.116552 14.3781 0.0384267 14.1906C-0.0396983 14.0031 0.00405172 13.7906 0.144677 13.6469L0.154052 13.6375C0.163427 13.6281 0.175927 13.6156 0.194677 13.5938C0.229052 13.5562 0.282177 13.4969 0.347802 13.4156C0.475927 13.2594 0.647802 13.0281 0.822802 12.7406C1.1353 12.2219 1.43218 11.5406 1.49155 10.775C0.554052 9.7125 0.000926722 8.40938 0.000926722 7C0.000926722 3.40937 3.58218 0.5 8.00093 0.5C12.4197 0.5 16.0009 3.40937 16.0009 7Z"
                fill={color}
            />
        </svg>
    );
}

export default IconChatBubble;